import GoodsDetail from "./-goodsDetail";
import { goodsDetailSearchSchema } from "@/router/staticData";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/goods/goodsDetail")({
  validateSearch: goodsDetailSearchSchema,
  component: GoodsDetail,
});
